import { twdClass } from "../../../constants/tailwind.constants";
import { useDispatch, useSelector } from "react-redux";
import FaIcons from "../../common/FaIcons";
import { Button} from "../../ui/com_ui";
import { UPDATE_PAGE_CONFIG, SELECT_BLOCK_ONCLICK, RIGHT_PANEL_TOGGEL, UPDATE_RIGHT_PANEL_LEVELS, SELECT_ELEMENT} from "../../../constants/action.constants";
// import { GenetateForm } from "../../form/GenerateForm";
import SettingsPanel from "../../form/SettingsPanel";
import styled from "styled-components";
import PageConfig from "./PageConfig";

//import RestyleBlock from "./RestyleBlock";
import { useState, useEffect, useRef } from "react";


const RightIcons = ({  }) => {
  const dispatch = useDispatch();

  const {
    openRightPanel,
    rightPanelLevels,
    selectElement,
  } = useSelector((state) => state.studioDetails);  

  const openBlocksPanel = () => {
    dispatch({ type: RIGHT_PANEL_TOGGEL, data: true });
    dispatch({
      type: UPDATE_PAGE_CONFIG,
      data: {
        active:true,
        component:<PageConfig/>
      },
    });
    /*dispatch({
      type: UPDATE_PAGE_CONFIG,
      data: {        
        title: "Page Designs",
        desc:'Sections and blocks are pre-designed building blocks to help you create and design your website.',
        img:'section_img.png',
        color:'primary', 
        component: <SectionsPanel {...{full:true}}/>,
      },
    });*/
  };
  
  return (
    <div className={twdClass(`py-2`)}>
      <div className={twdClass("transform rotate-90 whitespace-nowrap origin-center flex gap-2")}>
        <Button onClick={openBlocksPanel} 
          type={'default'}
          iconImg={'file-check.svg'}
          cType={'iconText'}
          size={'sm'}
          color={'white'}
          className={'inline-block'}
        > 
        Page Config           
        </Button> 
      </div>
    </div>
  );
};

export default RightIcons;